module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1u5XmW/tc-custom/9781634862257.jpg?1723407365353",
      "alt": "This image is the cover for the book Working Men Box Set"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Working Men Box Set\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Most of us spend forty hours or more a week at the workplace. Shuffling papers at a desk job, taking orders, waiting tables, working in the field, punching a time clock. Whether it's a career or simply a job to be done, we do whatever it takes to make a living. Sometimes the people we meet at work are among the best -- and the worst -- we'll ever know."), _c('br'), _c('br'), _c('em', [_vm._v("Working Men")]), _vm._v("contains 14 short, sexy stories about gay men who find love and lust in the workplace. From harmless, sweet flirting to fulfilling hot sex, these stories show you just how much some men enjoy their line of work."), _c('br'), _c('br'), _vm._v("Contains the stories: "), _c('i', [_vm._v("At Your Service, Cafe de l'Amour, Car Trouble, Closing Time, Easily Addicted, Lunch Break, Makin' Copies, On the Job, Opening Day at the County Fair, Order Up, Pleasure Cruise, Speed Trap, Summer Kisses and Ice Cream Dreams,")]), _vm._v(" and "), _c('i', [_vm._v("Tech Support.")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      J.M. Snyder\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0